import { render, staticRenderFns } from "./backoffice-surgery-solicitation-details.vue?vue&type=template&id=0db7d69a"
import script from "./backoffice-surgery-solicitation-details.vue?vue&type=script&lang=ts"
export * from "./backoffice-surgery-solicitation-details.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports